import { useOrderFlowContext } from "@src/app/order-flow-context";
import Button from "../../components/button/Button";

interface Props {
  data: any;
}

const ServiceUserGate = ({ data }: Props) => {
  const { handleContinue } = useOrderFlowContext();

  return (
    <div className="fm-o-service-user-gate">
      <div className="fm-o-service-user-gate__content">
        <div className="fm-o-service-user-gate__columns">
          <h2 className="fm-o-service-user-gate__title">{data.login?.title}</h2>
          {data.login?.message && <div className="fm-o-service-user-gate__subtitle">{data.login?.message}</div>}
          <Button
            text={data.login?.ctaText}
            url={data.login?.ctaUrl}
            link={true}
            mainClass="fm-o-service-user-gate__login-btn"
            styleModifier={["fm-a-button--blue"]}
          />
        </div>
        <div className="fm-o-service-user-gate__separator"></div>
        <div className="fm-o-service-user-gate__columns">
          <h2 className="fm-o-service-user-gate__title">{data.setup?.title}</h2>
          {data.setup?.message && <div className="fm-o-service-user-gate__subtitle">{data.setup?.message}</div>}
          <Button
            text={data.setup?.ctaText}
            onClick={handleContinue}
            mainClass="fm-o-service-user-gate__setup-btn"
            styleModifier={["fm-a-button--dark"]}
          />
        </div>
      </div>
    </div>
  );
};

export default ServiceUserGate;
